import React from 'react';
import { Help } from '@mui/icons-material';
import md from '../../markdown';
import QuestionAnswer from "./QuestionAnswer.jsx";

export default function Question({ block, questionCounter, lessonId, answers }) {
  let content = block.content || '';

  // Underscores are interpretted as markdown,
  // so escape any used as blanks (more than 3 in a row)
  const regex = /([_]{3,})/gm;
  content = content.replace(regex, match => {
    return '\\_'.repeat(match.length);
  });

  return (
    <div className="lesson-block lesson-block-question mb-4" key={block.id}>
      <div className="question-content">
        <Help className="question-icon" />
        <ol start={questionCounter}>
          <li
            key={block.id}
            data-name={block.name}
            data-id={block.id}
            dangerouslySetInnerHTML={{
              __html: md.makeHtml(content)
            }}
          />
        </ol>
      </div>

      <QuestionAnswer block={block} lessonId={lessonId} answers={answers} />
    </div>
  );
}
